import React, { useEffect, useState } from "react";
import { collection, addDoc, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../styles/Reviews.css";

const Reviews = () => {
  
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(0);

  
  const [reviews, setReviews] = useState([]);

  
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const q = query(
          collection(db, "reviews"),
          orderBy("createdAt", "desc")
        );

        const querySnapshot = await getDocs(q);

        const reviewsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setReviews(reviewsData);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, []);

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !message || rating === 0) {
      alert("Please fill all fields and select rating");
      return;
    }

    try {
      await addDoc(collection(db, "reviews"), {
        name,
        message,
        rating,
        createdAt: new Date(),
      });

      alert("Review submitted successfully!");

      setName("");
      setMessage("");
      setRating(0);

      
      window.location.reload();

    } catch (error) {
      console.error("Error adding review:", error);
    }
  };

  return (
    <>
      
      <Navbar />

      
      <div className="reviews-container">

        <h2>Clients Reviews</h2>

        
        <form onSubmit={handleSubmit} className="review-form">

          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <textarea
            placeholder="Write your review..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          
          <div className="stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                onClick={() => setRating(star)}
                style={{
                  cursor: "pointer",
                  fontSize: "22px",
                  color: star <= rating ? "gold" : "gray",
                }}
              >
                ★
              </span>
            ))}
          </div>

          <button type="submit">Submit Review</button>
        </form>

        
        <div className="reviews-list">
          {reviews.length === 0 ? (
            <p>No reviews yet.</p>
          ) : (
            reviews.map((review) => (
              <div key={review.id} className="review-card">
                <h4>{review.name}</h4>
                <p>{review.message}</p>
                <p>{"⭐".repeat(review.rating)}</p>
              </div>
            ))
          )}
        </div>

      </div>

      
      <Footer />
    </>
  );
};

export default Reviews;